var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentDispensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4638_357135)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8915 11.4783C19.963 10.9959 20 10.5023 20 10C20 8.57779 19.7031 7.22492 19.1679 6H24V11.4783H19.8915ZM18.5217 15.2353C19.0795 14.3294 19.4968 13.3278 19.7434 12.2609H24V17.7391H18.5217V15.2353ZM16.3334 17.7391C16.8471 17.3182 17.3182 16.8471 17.7391 16.3334V17.7391H16.3334ZM12.2609 19.7434C13.3278 19.4968 14.3294 19.0795 15.2353 18.5217H17.7391V24H12.2609V19.7434ZM6 19.1679C7.22492 19.7031 8.57779 20 10 20C10.5023 20 10.9959 19.963 11.4783 19.8915V24H6V19.1679ZM24 18.5217H18.5217V24H24V18.5217Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FEFEFE",
    stroke: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95015 3L4.8641 7.52472L4.86543 7.52593C4.32389 8.21431 4 9.08787 4 10.0385C4 12.2597 5.76855 14.0604 7.95016 14.0604C10.1318 14.0604 11.9003 12.2597 11.9003 10.0385C11.9003 9.08787 11.5764 8.21431 11.0349 7.52593L11.0362 7.52472L7.95015 3Z",
    fill: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95016 3L4.72008 7.52472L4.72119 7.52593C4.26991 8.21431 4 9.08787 4 10.0385C4 12.7592 6.13215 14.0604 7.95016 14.0604C7.95016 14.0604 5.09727 12.3641 5.09727 10.0664C5.09727 7.30128 7.95016 3 7.95016 3Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6599 10.4335L12.4255 12.3726L12.426 12.3732C12.2094 12.6682 12.0798 13.0426 12.0798 13.45C12.0798 14.4019 12.7873 15.1737 13.6599 15.1737C14.5325 15.1737 15.24 14.4019 15.24 13.45C15.24 13.0426 15.1104 12.6682 14.8938 12.3732L14.8943 12.3726L13.6599 10.4335Z",
    fill: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6599 10.4335L12.4255 12.3726L12.426 12.3732C12.2094 12.6682 12.0798 13.0426 12.0798 13.45C12.0798 14.4019 12.7873 15.1737 13.6599 15.1737C13.6599 15.1737 12.6065 14.4466 12.6065 13.4619C12.6065 12.2769 13.6599 10.4335 13.6599 10.4335Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9309 13.6654L10.3137 14.9582L10.314 14.9585C10.2056 15.1552 10.1409 15.4048 10.1409 15.6764C10.1409 16.311 10.4946 16.8255 10.9309 16.8255C11.3672 16.8255 11.7209 16.311 11.7209 15.6764C11.7209 15.4048 11.6562 15.1552 11.5478 14.9585L11.5481 14.9582L10.9309 13.6654Z",
    fill: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9309 13.6654L10.3137 14.9582L10.314 14.9585C10.2056 15.1552 10.1409 15.4048 10.1409 15.6764C10.1409 16.311 10.4946 16.8255 10.9309 16.8255C10.9309 16.8255 10.4042 16.3409 10.4042 15.6844C10.4042 14.8943 10.9309 13.6654 10.9309 13.6654Z",
    fill: "#006AF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4638_357135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentDispensed);
export default __webpack_public_path__ + "static/media/Experiment_Dispensed.439d0b125872b217f08e4a5b84486c2c.svg";
export { ForwardRef as ReactComponent };